import React, { Fragment } from "react";

import { EuiBreadcrumbs, EuiSpacer } from "@elastic/eui";

export default function ManualBreadcrumbs() {
  const breadcrumbs = [
    {
      text: "Übersicht",
      href: "/de/Innenkameras/IN-8815_QFHD/",
    },
    {
      text: "Spezifikationen",
      href: "/de/Innenkameras/IN-8815_QFHD/Technische_Spezifikationen/",
    },
    {
      text: "Features",
      href: "/de/Innenkameras/IN-8815_QFHD/Produkt_Features/",
    },
    {
      text: "Installation",
      href: "/de/Innenkameras/IN-8815_QFHD/Schnell_Installation/",
    },
    {
      text: "Objektivjustage",
      href: "/de/Innenkameras/IN-8815_QFHD/Objektivjustage/",
    },
    {
      text: "Handbuch",
      href: "/de/Innenkameras/IN-8815_QFHD/Handbuch/",
    },
    {
      text: "◄ Innenkameras",
      href: "/de/Innenkameras/",
    },
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={10}
        aria-label="INSTAR IN-8415 2k+ WQHD Online Handbuch Kapitel"
      />
      <EuiSpacer />
    </Fragment>
  );
}
